import apiClient, { API_ENDPOINTS, dispatchAndResolve, rejectWithError } from "api";
import * as types from "./types.jsx";

const { timeSchedule } = API_ENDPOINTS;

const rejectScheduleError = (error, label) => rejectWithError(error, label);

export const createTimeSchedule = (timeScheduleData) => async (dispatch) => {
  try {
    const data = await apiClient.post(timeSchedule.create, timeScheduleData);
    return dispatchAndResolve(dispatch, types.CREATE_TIME_SCHEDULE, data);
  } catch (error) {
    return rejectScheduleError(error, "Error creating time schedule");
  }
};

export const saveScheduledProduct = async (productData) => {
  try {
    return await apiClient.post(timeSchedule.saveScheduledProduct, productData);
  } catch (error) {
    return rejectScheduleError(error, "Error saving scheduled product");
  }
};

export const createBulkScheduledProducts = async (scheduledProducts) => {
  try {
    return await apiClient.post(timeSchedule.createBulkScheduledProduct, scheduledProducts);
  } catch (error) {
    return rejectScheduleError(error, "Error creating bulk scheduled products");
  }
};
